import { useNavigationStore } from '@/store/useNavigationStore';

export function useAdjacentPages(web_path) {
    const pages = useNavigationStore((s) => s.pages);
    const menuPages = pages.filter((page) => page.menu === 'yes');
    const idx = menuPages.findIndex((p) => p.web_path === web_path);

    if (idx === -1) return { prev: null, next: null };

    return {
        prev: idx > 0 ? menuPages[idx - 1] : null,
        next: idx < menuPages.length - 1 ? menuPages[idx + 1] : null,
    };
}
